var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "cover-uploader" }, [_c('el-upload', { ref: "uploader", attrs: { "with-credentials": "", "list-type": "picture-card", "accept": _vm.accept, "action": _vm.uploadFileUrl, "file-list": _vm.uploadList, "on-success": _vm.handleUploadSuccess, "on-error": _vm.handleUploadError } }, [_c('i', { staticClass: "el-icon-plus" }), _vm._v(" "), _c('div', { staticClass: "el-upload__tip", attrs: { "slot": "tip" }, slot: "tip" }, [_vm._v(_vm._s(_vm.tips))])])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };